<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <BitQLoginPage :service_title="service_title" :showcase_id="showcase_id"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import BitQLoginPage from '@/components/bitq/BitQLoginPage'

export default {
  name: 'BitQMusei',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Teatro, Mostre, Musei", link : 'conv-bitq-musei' } ],

        // Nome welfarebit del servizio
        service_title : "Teatro, Mostre, Musei",

        // Identificativo della vetrina ( fornito da BitQ )
        showcase_id : 18
    }
  },
  components: {
    PageTagline,
    BitQLoginPage
  }
}
</script>

<style scoped></style>